import { render, staticRenderFns } from "./ModalValidatedSkills.vue?vue&type=template&id=62b523e6&"
import script from "./ModalValidatedSkills.vue?vue&type=script&lang=js&"
export * from "./ModalValidatedSkills.vue?vue&type=script&lang=js&"
import style0 from "./ModalValidatedSkills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports